module.exports = __webpack_public_path__ + "img/avatar.af019c24.svg";